<app-provider-details-layout>
  <ng-container *transloco="let t; read: 'providers.detailPage'">
    <!-- Feed health (GTFS diagnostics are per feed, not per stop) -->
    <div class="flex flex-col gap-5 rounded-card bg-card p-6 shadow-hairline">
      <div class="flex flex-wrap items-baseline justify-between gap-2">
        <span class="font-display text-[12px] font-semibold uppercase tracking-wide text-ink-2">{{ t('feedHealth.title') }}</span>
        @if (health().newestAge && health().oldestAge) {
          <span class="text-[12px] text-ink-3">{{ t('feedHealth.snapshotsRange', { newest: health().newestAge, oldest: health().oldestAge }) }}</span>
        }
      </div>

      @if (!feeds().length) {
        <div class="flex max-w-[440px] flex-col items-start gap-2 rounded-control bg-sunken p-6">
          <span class="text-[16px] font-semibold text-ink-1">{{ t('gtfsHealth.emptyTitle') }}</span>
          <p class="m-0 text-[13px] leading-5 text-ink-2">{{ t('gtfsHealth.emptyBody') }}</p>
          <button
            type="button"
            (click)="addFeed()"
            class="mt-2 flex h-8 items-center gap-1.5 rounded-control bg-action px-3 text-[13px] font-semibold text-action-text transition-[filter] duration-150 hover:brightness-90"
          >
            <app-icon name="icon-content-add24px" [size]="16" />
            {{ t('actions.addFeed') }}
          </button>
        </div>
      } @else if (isDiagnosticsLoading()) {
        <span class="text-[13px] text-ink-3">—</span>
      } @else {
        @let h = health();
        <div class="grid grid-cols-2 gap-8">
          <div>
            <div class="mb-4 text-[11px] font-bold uppercase tracking-wide text-ink-3">{{ t('gtfsHealth.staticTitle') }}</div>
            <app-stacked-bar [segments]="h.staticSegments" />
          </div>
          <div>
            <div class="mb-4 text-[11px] font-bold uppercase tracking-wide text-ink-3">{{ t('gtfsHealth.realtimeTitle') }}</div>
            <app-stacked-bar [segments]="h.realtimeSegments" />
          </div>
        </div>

        <!-- Needs attention -->
        <div class="flex flex-col border-t border-hairline pt-4">
          <span class="pb-2 text-[11px] font-bold uppercase tracking-wide text-ink-3">{{ t('feedHealth.needsAttention', { count: h.attention.length }) }}</span>
          @for (row of h.attention; track row.feed.id) {
            <a
              [routerLink]="feedLink(row.feed)"
              class="grid grid-cols-[180px_112px_minmax(0,1fr)_76px] items-center gap-3 border-t border-hairline py-2.5 text-[13px] transition-colors duration-150 hover:bg-sunken"
            >
              <span class="flex min-w-0 flex-col">
                <span class="truncate font-semibold text-ink-1">{{ row.feed.name }}</span>
                <span class="truncate text-[12px] text-ink-3">{{ row.tenantName }}</span>
              </span>
              <span>
                <app-label-badge [dot]="attentionDot[row.kind]">{{ t('gtfsHealth.kind.' + row.kind) }}</app-label-badge>
              </span>
              <span class="truncate text-ink-2" [attr.title]="row.message">{{ row.message }}</span>
              <span class="text-right text-[12px] text-ink-3">{{ row.age ?? '—' }}</span>
            </a>
          } @empty {
            <span class="border-t border-hairline py-2.5 text-[13px] text-ink-3">{{ t('gtfsHealth.allHealthy') }}</span>
          }
        </div>
      }
    </div>
  </ng-container>
</app-provider-details-layout>
